<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="700px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        :rules="rules"
        @keyup.enter.native="submitForm('dataForm')"
        :disabled="type === 3"
        :class="{ 'no-star': type === 3 }"
      >
        <el-form-item
          label="产品系列"
          :label-width="formLabelWidth"
          prop="type"
        >
          <el-select
            class="w-100"
            v-model="dataForm.type"
            placeholder="请选择产品系列"
            filterable
            @blur="selectTypeBlur"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品编号" :label-width="formLabelWidth" prop="no">
          <el-input
            show-word-limit
            v-model="dataForm.no"
            maxlength="50"
            placeholder="请输入产品编号，最多50字，字母、数字、空格、中划线与下划线组合"
            autocomplete="off"
            :disabled="type === 2 && existsVersion"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="产品名称"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            show-word-limit
            v-model="dataForm.name"
            maxlength="25"
            placeholder="请填写中国境内使用的产品名称，最多25字"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="运行端"
          :label-width="formLabelWidth"
          prop="terminal"
        >
          <el-select
            class="w-100"
            v-model="dataForm.terminal"
            placeholder="请选择运行端"
            filterable
            @blur="selectTerminalBlur"
          >
            <el-option
              v-for="item in terminals"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="客户名称"
          :label-width="formLabelWidth"
          prop="customer"
        >
          <el-input
            show-word-limit
            v-model="dataForm.customer"
            maxlength="25"
            placeholder="请输入客户名称，最多25字"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="产品描述"
          :label-width="formLabelWidth"
          prop="describe"
        >
          <el-input
            type="textarea"
            :rows="4"
            maxlength="500"
            placeholder="请填写中国境内产品描述，用于对外展示"
            show-word-limit
            v-model="dataForm.describe"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input
            type="textarea"
            :rows="4"
            maxlength="100"
            placeholder="请输入备注，最多100字"
            show-word-limit
            v-model="dataForm.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <MarketLink ref="marketLinkRef" :type="type"></MarketLink>
      <MultiLanguage ref="multiLanguageRef" :type="type"></MultiLanguage>
      <div class="qrcode" v-if="type === 3 && existsOfficialVersion">
        <div class="qrcodeurl">产品二维码 {{ this.qrcodeurl }}</div>
        <canvas id="QRCode_box"></canvas>
      </div>
      <div slot="footer" class="dialog-footer" v-if="type !== 3">
        <span v-if="showError" class="error-msg">{{ errorMsg }}</span>
        <el-button @click="resetForm('dataForm')">取消</el-button>
        <el-button type="primary" @click="submitForm('dataForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import Vue from 'vue'
// import axios from 'axios'
import encryption from '../../../utils/encryption.js'
import MultiLanguage from '@/components/MultiLanguage'
import MarketLink from '@/components/MarketLink'
import QRCode from 'qrcode'
// import httpMethods from '@/api/product/http.js'
// import httpMethods from '../../../api/equipment/http'
export default {
  props: ['status'],
  components: {
    MultiLanguage,
    MarketLink
  },
  data() {
    // 产品编号校验规则
    var validateNo = (rule, value, callback) => {
      // rule validateNo 对象
      // value validateNo 数值
      // callback 回调函数
      const r = /^[a-zA-Z0-9_-\s]*$/ // 正整数 ^[0-9a-zA-Z_]{1,}$
      if (value == null || String(value).trim() === '') {
        callback(new Error('请输入产品编号'))
      } else if (!r.test(value)) {
        callback(new Error('产品编号为字母、数字、空格、中划线与下划线组合'))
      } else {
        callback()
      }
    }
    return {
      existsOfficialVersion: true, // 是否存在正式的版本
      existsVersion: true, // 是否存在任意状态的版本
      publickey: '', // sm2获取的公钥
      time: '', // sm2获取的时间戳
      showError: false,
      errorMsg: '',
      visible: false,
      type: '',
      msg: '',
      versionId: '', // 最新版本id
      title: '新增产品信息',
      currentVersion: {},
      proinfo: {},
      currentId: '',
      qrcodeurl: '',
      dataForm: {
        type: '',
        no: '',
        name: '',
        terminal: '',
        customer: '',
        describe: '',
        remark: ''
      },

      rules: {
        type: [
          { required: true, message: '请选择产品系列', trigger: 'change' },
          { max: 25, message: '最多25字', trigger: 'blur' }
        ],
        no: [
          { required: true, message: '请输入产品编号', trigger: 'blur' },
          { max: 50, message: '最多50字', trigger: 'blur' },
          { validator: validateNo, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
          { max: 25, message: '最多25字', trigger: 'blur' }
        ],
        terminal: [
          { required: true, message: '请选择运行端', trigger: 'change' },
          { max: 25, message: '最多25字', trigger: 'blur' }
        ],
        customer: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
          { max: 25, message: '最多25字', trigger: 'blur' }
        ],
        describe: [
          { required: true, message: '请输入产品描述', trigger: 'blur' },
          { max: 500, message: '最多500字', trigger: 'blur' }
        ],
        remark: [
          { message: '请输入备注', trigger: 'blur' },
          { max: 100, message: '最多100字', trigger: 'blur' }
        ]
      },
      typeOptions: [],
      terminals: [],
      formLabelWidth: '120px',
      linkList: [], // 应用市场链接添加的列表
      langList: [], // 多语言添加的列表
      languageSendList: [], // 给后台发送的多语言列表
      linkSendList: [], // 给后台返回的应用市场链接列表
      lingSend: '' // 给后台返回的应用市场拼接字符串
    }
  },
  created() {
    this.getTerminals()
    this.getTypes()
  },
  methods: {
    init(info) {
      this.visible = true
      this.showError = false
      if (info === '') {
        // 新增
        this.type = 1
        this.title = '新增产品信息'
        this.$nextTick(() => {
          this.$refs.dataForm.resetFields()
          this.getTerminals()
          this.getTypes()
          this.currentId = ''
          this.dataForm.no = ''
          this.dataForm.name = ''
          this.dataForm.customer = ''
          this.dataForm.describe = ''
          this.dataForm.remark = ''
          this.$refs.multiLanguageRef.init('')
          this.$refs.marketLinkRef.init('')
        })
      } else if (info.id !== '' && this.status === 'desc') {
        // 产品详情
        this.title = '产品详情'
        this.type = 3
        this.$nextTick(() => {
          this.currentId = info.id
          this.$refs.dataForm.resetFields()
          this.dataForm.type = info.productSeries
          this.dataForm.terminal = info.execEnd
          this.getTerminals()
          this.getTypes()
          this.getMultiLanguage()
          // this.getKeys()
          // this.getQRCode()
        })
      } else {
        // 编辑
        this.title = '编辑产品信息'
        this.type = 2
        this.$nextTick(() => {
          this.currentId = info.id
          this.existsOfficialVersion = info.existsOfficialVersion
          this.existsVersion = info.existsVersion
          this.$refs.dataForm.resetFields()
          this.dataForm.type = info.productSeries
          this.dataForm.terminal = info.execEnd
          this.getTerminals()
          this.getTypes()
          this.getMultiLanguage()
        })
      }
    },
    // 查询产品多语言信息
    getMultiLanguage() {
      this.tabLoding = true
      this.$http({
        url: this.$http.adornUrl('/api/app/getProductInfoMultiLanguage'),
        method: 'get',
        params: this.$http.adornParams({
          id: this.currentId
        })
      })
        .then((res) => {
          if (res.resp_code === 0) {
            this.proinfo = res.data
            this.existsOfficialVersion = res.data.existsOfficialVersion
            this.langList = this.proinfo.list
            this.dataForm.no = this.proinfo.productNumber
            this.dataForm.name = this.proinfo.productName
            this.dataForm.customer = this.proinfo.userName
            this.dataForm.describe = this.proinfo.productDescribe
            this.dataForm.remark = this.proinfo.note
            this.$nextTick(() => {
              this.$refs.multiLanguageRef.init(this.langList)
              this.$refs.marketLinkRef.init(this.proinfo.appMarketLink)
            })
            if (res.data.existsOfficialVersion && this.type === 3) {
              this.getLastVersion()
            }
            // this.getQRCode()
          } else {
            this.langList = []
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {})
    },
    // 获取产品系列
    getTypes() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getProductSeries'),
        method: 'get'
      })
        .then((res) => {
          const data = res.data
          if (data && res.resp_code === 0) {
            this.typeOptions = data.list
            if (this.type === 1 && this.typeOptions.length > 0) {
              // 新增
              this.dataForm.type = this.typeOptions[0]
            }
          } else {
            this.typeOptions = []
            this.$message.error(res.resp_msg)
          }
        })
        .catch((err) => {
          this.typeOptions = []
          console.log('err => ', err)
        })
    },
    // 获取运行端
    getTerminals() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getExecEnd'),
        method: 'get'
      })
        .then((res) => {
          const data = res.data
          if (data && res.resp_code === 0) {
            this.terminals = data.list
            if (this.type === 1 && this.terminals.length > 0) {
              this.dataForm.terminal = this.terminals[0]
            }
          } else {
            this.terminals = []
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {
          this.terminals = []
        })
    },
    // 获取当前产品最新版本
    getLastVersion() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getLatestProductVersion'),
        method: 'get',
        params: this.$http.adornParams({
          productId: this.currentId
        })
      }).then((res) => {
        const data = res.data
        if (data && res.resp_code === 0) {
          this.versionId = res.data.id
          this.getQRCode()
        } else {
          this.versionId = ''
          this.$message.error(res.resp_msg)
        }
      })
    },
    // 获取sm2的公钥和时间戳
    // getKeys() {
    //   httpMethods
    //     .keys()
    //     .then((res) => {
    //       this.loading = false
    //       const data = res.data
    //       if (data && res.resp_code === 0) {
    //         this.publickey = '04' + res.data.PublicKey
    //         this.time = res.data.time
    //       } else {
    //         this.publickey = ''
    //         this.time = ''
    //         this.$message.error(res.resp_msg)
    //       }
    //     })
    //     .catch(() => {})
    // },
    selectTerminalBlur(e) {
      if (e.target.value) {
        this.dataForm.terminal = e.target.value
      }
    },
    selectTypeBlur(e) {
      if (e.target.value) {
        this.dataForm.type = e.target.value
      }
    },
    submitForm(formName) {
      // 应用市场链接为空的情况
      const hasLlinkEmpty = this.$refs.marketLinkRef.submit()
      if (hasLlinkEmpty) {
        return
      }
      const hasLanguageEmpty = this.$refs.multiLanguageRef.submit()
      if (hasLanguageEmpty) {
        // 多语言有为空的情况
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dataForm.name.trim() === '') {
            this.$message.error('产品名称不能是空格')
            return
          }
          if (this.dataForm.customer.trim() === '') {
            this.$message.error('客户名称不能是空格')
            return
          }
          if (
            this.dataForm.remark !== '' &&
            this.dataForm.remark.trim() === ''
          ) {
            this.$message.error('备注不能是空格')
            return
          }
          // 应用市场链接
          this.linkList = this.$refs.marketLinkRef.marketLink
          this.lingSendList = []
          this.linkList.forEach((item) => {
            this.lingSendList.push(item.url)
          })
          this.lingSend = this.lingSendList.join(';')
          // 应用市场链接不能重复，不能超过15个
          if (this.judgeLinkRepeat()) {
            this.showError = true
            this.errorMsg = '应用市场链接不得重复'
            return
          }
          if (this.linkList.length > 15) {
            this.$message.error('应用市场链接不得超过15个')
            return
          }

          // 多语言
          this.langList = this.$refs.multiLanguageRef.langList
          if (this.judgeLanguageRepeat()) {
            this.showError = true
            this.errorMsg = '多语言类型选项重复'
            return
          }
          if (this.langList.length > 14) {
            this.$message.error('多语言不得超过14个')
            return
          }
          this.languageSendList = []
          this.langList.forEach((item) => {
            const obj = {
              productDescribe: item.multiLanguageProductDescribe,
              languageKey: item.languageKey,
              productName: item.multiLanguageProductName
            }
            this.languageSendList.push(obj)
          })
          if (this.type === 1) {
            // 新增
            if (this.dataForm.no.trim() === '') {
              this.$message.error('产品编号不能是空格')
              return
            }
            this.add()
          } else {
            // 编辑
            this.update()
          }
        } else {
          return false
        }
      })
    },
    // 判断应用市场链接的重复
    judgeLinkRepeat() {
      const urlsList = []
      this.linkList.forEach((item) => {
        urlsList.push(item.url)
      })
      const newList = [...new Set(urlsList)]
      if (newList.length !== urlsList.length) {
        return true
      }
      return false
    },
    // 判断多语言的重复
    judgeLanguageRepeat() {
      const langs = []
      this.langList.forEach((item) => {
        langs.push(item.languageKey)
      })
      const newList = [...new Set(langs)]
      if (newList.length !== langs.length) {
        return true
      }
      return false
    },
    // 新增
    add() {
      this.$http({
        url: this.$http.adornUrl('/api/app/insertProductInfo'),
        method: 'post',
        data: this.$http.adornData({
          execEnd: this.dataForm.terminal,
          note: this.dataForm.remark.trim(),
          productName: this.dataForm.name.trim(),
          productNumber: this.dataForm.no,
          productSeries: this.dataForm.type,
          userName: this.dataForm.customer.trim(),
          productDescribe: this.dataForm.describe.trim(),
          appMarketLink: this.lingSend,
          list:
            this.languageSendList.length === 0 ? null : this.languageSendList
        })
      }).then((res) => {
        if (res.resp_code === 0) {
          this.visible = false
          this.$emit('refreshDataList')
          this.$message({
            message: '添加成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.resp_msg)
        }
      })
    },
    // 编辑
    update() {
      this.$http({
        url: this.$http.adornUrl('/api/app/updateProductInfo'),
        method: 'post',
        data: this.$http.adornData({
          productId: this.currentId,
          execEnd: this.dataForm.terminal,
          note: this.dataForm.remark.trim(),
          productName: this.dataForm.name.trim(),
          productNumber: this.dataForm.no,
          productSeries: this.dataForm.type,
          userName: this.dataForm.customer.trim(),
          productDescribe: this.dataForm.describe.trim(),
          appMarketLink: this.lingSend,
          list:
            this.languageSendList.length === 0 ? null : this.languageSendList
        })
      }).then((res) => {
        if (res.resp_code === 0) {
          this.visible = false
          this.$emit('refreshDataList')
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.resp_msg)
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.visible = false
    },
    // 生成二维码
    getQRCode() {
      const opts = {
        errorCorrectionLevel: 'H', // 容错级别
        type: 'image/png', // 生成的二维码类型
        quality: 0.3, // 二维码质量
        margin: 12, // 二维码留白边距
        width: 200, // 宽
        height: 180, // 高
        color: {
          dark: '#333333', // 前景色
          light: '#fff' // 背景色
        }
      }
      // 二维码后面的参数，产品id+版本id
      // const sm2 = require('sm-crypto').sm2
      // const cipherMode = 1 // 1 - C1C3C2，0 - C1C2C3，默认为1
      // const productId = sm2.doEncrypt(
      //   this.proinfo.id,
      //   this.publickey,
      //   cipherMode
      // ) // sm2加密
      // const versionId = sm2.doEncrypt(
      //   this.versionId,
      //   this.publickey,
      //   cipherMode
      // ) // sm2加密
      const productId = encryption.Encrypt(this.proinfo.id)
      // const versionId = encryption.Encrypt(this.versionId)
      this.qrcodeurl =
        location.origin +
        '/#/productload?productId=' +
        encodeURIComponent(productId) // 生成的二维码为URL地址js
      const msg = document.getElementById('QRCode_box')
      QRCode.toCanvas(msg, this.qrcodeurl, opts)
    }
  }
}
</script>

<style lang="scss" scoped>
.qrcode {
  text-align: center;
  .qrcodeurl {
    text-align: left;
  }
}
.error-msg {
  color: red;
  font-size: 12px;
  margin-right: 20px;
}
::v-deep {
  .no-star {
    .el-form-item.is-required:not(.is-no-asterisk)
      .el-form-item__label-wrap
      > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
      display: none !important;
    }
  }
  .el-dialog__body {
    max-height: calc(100vh - 250px);
    overflow-y: auto;
  }
}
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
